import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class GetOSArchitectureQuery {
  constructor(
    private readonly q_dispatcher: QueryDispatcher,
    private readonly frontend
  ) {}

  async run() {
    let args = {}

    try {
      this.frontend.loading_def_set_windows_64 = true
      let data = await this.q_dispatcher.dispatch('get.os.architecture.settings', args)
      this.frontend.def_set_windows_64 = data
    } catch (error) {
      console.error('Error get os architecture settings', error)
    }
    this.frontend.loading_def_set_windows_64 = false
  }
}